
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.84 0A.838.838 0 000 .838v4.308a.838.838 0 00.838.84.838.838 0 00.836-.84V2.86l4.464 4.465a.838.838 0 001.183 0 .838.838 0 000-1.184L2.86 1.678h2.29a.838.838 0 00.835-.839.838.838 0 00-.836-.838zm10.39 10.432a.838.838 0 00-.552.245.838.838 0 000 1.185l4.462 4.462h-2.289a.838.838 0 00-.835.839.838.838 0 00.835.838h4.31a.838.838 0 00.839-.838v-4.308a.838.838 0 00-.839-.84.838.838 0 00-.835.839v2.285l-4.464-4.462a.838.838 0 00-.632-.245z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    